// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import "./DDReport.css";
// import { Link, useNavigate } from "react-router-dom";
// import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
// import { useSelector, useDispatch } from "react-redux";
// import { FaRupeeSign } from "react-icons/fa";

// const secondaryTabs = ["All", "Active", "Closed","Pending","Matured", "Pre-Closed", "Reject"];
// const rowsPerPage = 10;

// const RDReport = () => {
//   const navigate = useNavigate();
//    const dispatch = useDispatch();

//   const [activeMainTab, setActiveMainTab] = useState("RD");
//   const [activeSecondary, setActiveSecondary] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [accounts, setAccounts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const { profile } = useSelector((state) => state.userProfile);
//   const [frequency, setFrequency] = useState("All");

//   const [currentPage, setCurrentPage] = useState(1);
//   // const [totalPages, setTotalPages] = useState(1);

// const handleViewEmi = (account) => {
//   navigate(`/Deposit/EmiDetails/${account.id}`, { state: { account } });
// };

// const handleAlternatePay = (account) => {
//   navigate(`/Banking/Report/AlternatePay/${account.id}`, { state: { account } });
// };

//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // Fetch Accounts
//   const fetchAccounts = async () => {
//     try {
//       setLoading(true);
//       const superAdminId = profile.superAdminId || 14;
//       const branchId = localStorage.getItem("userId") || 56;

//       const res = await axios.get("https://payyug.in/api/deposit/list", {
//         params: {
//           superAdminId,
//           branchId,
//           page: currentPage,
//           limit: rowsPerPage,
//           accountType: activeMainTab,
//           status: activeSecondary !== "All" ? activeSecondary : undefined,
//           // search: searchQuery || undefined,
//         },
//       });

//       console.log("deposit list:",res)
//       if (res.data.success) {
//         setAccounts(res.data.data || []);
//         // setTotalPages(res.data.totalPages || 1);
//       } else {
//         setAccounts([]);
//       }
//     } catch (err) {
//       console.error("Error fetching deposit accounts:", err);
//       setAccounts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // useEffect(() => {
//   //   fetchAccounts();
//   // }, [activeMainTab, activeSecondary, searchQuery, currentPage]);

//   useEffect(() => {
//     if (profile?.superAdminId) {
//       fetchAccounts();
//     }
//   }, [activeMainTab, activeSecondary, profile]);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [activeMainTab, activeSecondary,searchQuery,frequency]);

//   const filteredAccounts = useMemo(() => {
//     let data = [...accounts];

//     if (searchQuery.trim() !== "") {
//         const query = searchQuery.toLowerCase();

//         data = data.filter(
//           (acc) =>
//             acc.accountNo?.toLowerCase().includes(query) ||
//             acc.customerName?.toLowerCase().includes(query)
//         );
//       }

//     // 🔹 STATUS FILTER
//     if (activeSecondary !== "All") {
//       data = data.filter(
//         (acc) =>
//           acc.status?.toLowerCase() === activeSecondary.toLowerCase()
//       );
//     }

//     // 🔹 FREQUENCY FILTER
//     if (frequency !== "All") {
//       data = data.filter(
//         (acc) =>
//           acc.installmentFrequency?.toLowerCase() ===
//           frequency.toLowerCase()
//       );
//     }

//     return data;
//   }, [accounts, activeSecondary, frequency, searchQuery]);

//    const totalPages = filteredAccounts.length
//     ? Math.ceil(filteredAccounts.length / rowsPerPage)
//     : 0;

//   const paginatedAccounts = useMemo(() => {
//     const start = (currentPage - 1) * rowsPerPage;
//     const end = start + rowsPerPage;
//     return filteredAccounts.slice(start, end);
//   }, [filteredAccounts, currentPage]);

//   const renderTable = useMemo(() => {
//   if (loading) {
//     return (
//       <tr>
//         <td colSpan="15" style={{ textAlign: "center" }}>Loading...</td>
//       </tr>
//     );
//   }

//   if (!paginatedAccounts.length){
//     return (
//       <tr>
//         <td colSpan="15" style={{ textAlign: "center" }}>No Data Found</td>
//       </tr>
//     );
//   }

//   return paginatedAccounts.map((acc, index) => {
//     const isPending = acc.status === "Pending";
//     const isClosed=acc.status.toLowerCase()==="closed" || acc.status.toLowerCase()==="requested"||acc.status.toLowerCase()==="force_closed"

//     return (
//       <tr key={acc.id}>
//         {/* SN */}
//         <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>

//         {/* Account No */}
//         <td>{acc.accountNo}</td>

//         {/* Customer Name */}
//         <td>{acc.customerName || "--"}</td>

//         {/* Account Type */}
//         <td>{acc.accountType || "--"}</td>

//         {/* Scheme */}
//         <td>{acc.schemeName || "--"}</td>

//         {/* Frequency */}
//         <td>{acc.installmentFrequency || "--"}</td>

//         {/* ROI */}
//         <td>{acc.roi || "--"}%</td>

//         {/* Installment Amount */}
//         <td>₹{acc.amount?.toLocaleString() || 0}</td>

//         {/* Tenure */}
//         <td>{acc.tenure || "--"}</td>

//         {/* Principal Amount */}
//         <td>₹{acc.principalAmount?.toLocaleString() || "--"}</td>
//         <td>{acc?.openingDate?new Date(acc.openingDate).toLocaleDateString("en-GB"):"N/A"}</td>
//         <td>{acc?.status}</td>

//         {/* Passbook */}
//         <td>
//           <Link to={"/Banking/Report/RDDDPassbook"} state={{row:acc}} className="rd-cirtificate-open-btn">Open</Link>
//         </td>

//         {/* RD Certificate */}
//         <td>
//           {isPending ? (
//            <span className="status-badge-not-approved">Not Approved</span>
//           ) : (
//             <Link
//               to={"/Banking/Report/RDCertificates"}
//               className="rd-cirtificate-open-btn"
//               state={{ row: acc }}
//             >
//               Open
//             </Link>
//           )}
//         </td>
//         {/* Refer ID */}
//         {/* <td>{acc.referralId || "--"}</td> */}

//         {/* Nominee ID */}
//         {/* <td>{acc.nomineeCusId || "--"}</td> */}

//         {/* RD Cirtificate */}
//         {/* <td><Link to={"/Banking/Report/RDCertificates"} className="rd-cirtificate-open-btn" state={{ row: acc }}>Open</Link></td> */}
//         {/* <td><Link to={"/Banking/Report/Membership"} className="rd-cirtificate-open-btn" state={{ row: acc }}>Open</Link></td> */}

//         {/* Action */}
//         <td>
//           {isPending ? (
//             <span className="status-badge-not-approved">Not Approved</span>

//           ):isClosed?(
//             <button
//               className="DDFDReportview-btn"
//             >
//               Closing Letter
//             </button>
//           ) : (
//             <button
//               className="DDFDReportview-btn"
//               onClick={() => handleViewEmi(acc)}
//             >
//               <FaRupeeSign />

//             </button>
//           )}
//         </td>
//         <td>
//           {isPending ? (
//             <span className="status-badge-not-approved">Not Approved</span>

//           ) :isClosed?(
//             <span className="status-badge-not-approved">Closed</span>
//           ): (
//             <button
//               className="DDFDReportview-btn"
//               onClick={() => handleAlternatePay(acc)}
//             >
//               <FaRupeeSign />

//             </button>
//           )}
//         </td>
//       </tr>
//     );
//   });
// }, [paginatedAccounts, loading, currentPage]);

//   return (
//     <div className="DDFDReport-container">
//       <h2 style={{ textAlign: "center", marginBottom: 10 }}>
//         {activeMainTab} Account Report
//       </h2>

//       {/* Main Tabs */}
//       <div className="DDFDReport-main-tabs">
//         {["RD", "DD"].map((tab) => (
//           <button
//             key={tab}
//             className={`DDFDReport-main-btn ${
//               activeMainTab === tab ? "active" : ""
//             }`}
//             onClick={() => setActiveMainTab(tab)}
//           >
//             {tab} Report
//           </button>
//         ))}
//       </div>

//       {/* Secondary Tabs */}
//       <div className="DDFDReport-secondary-tabs">
//         {secondaryTabs.map((tab) => (
//           <button
//             key={tab}
//             className={`DDFDReport-secondary-btn ${
//               activeSecondary === tab ? "active" : ""
//             }`}
//             onClick={() => setActiveSecondary(tab)}
//           >
//             {tab}
//           </button>
//         ))}

//          <div className="dropdown-filter ">
//           <select
//             value={frequency}
//             onChange={(e) => setFrequency(e.target.value)}
//           >
//           <option value="All">All</option>
//           <option value="Daily">Daily</option>
//           <option value="Weekly">Weekly</option>
//           <option value="Monthly">Monthly</option>
//         </select>
//       </div>
//       </div>

//       {/* Search */}
//       <div className="DDFDReportsearch-box">
//         <input
//           type="text"
//           placeholder="Search by Account No / Customer..."
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>

//       {/* Table */}
//       <div className="DDFDReporttable-container">
//         <table className="DDFDReport-table">
//           <thead>
//             <tr>
//               <th>SN</th>
//               <th>Account No</th>
//               <th>Customer Name</th>
//               <th>Account Type</th>
//               <th>scheme Name</th>
//               <th>installment Frequency</th>
//               <th>ROI</th>
//               <th>Installment Amount</th>
//               <th>Tenure</th>
//               <th>Principal Amount</th>
//               <th>Opening Date</th>
//               <th>Status</th>
//               <th>Passbook</th>
//               <th>Certificate</th>
//               {/* <th>MemberShip Form</th> */}
//               {/* <th>Refer ID</th>
//               <th>Nominee ID</th> */}
//               <th>Action</th>
//               <th>Alternative Payment</th>
//             </tr>
//           </thead>
//           <tbody>{renderTable}</tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="DDFDReportpagination">
//         <button
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((p) => p - 1)}
//         >
//           Previous
//         </button>

//         <span>
//           Page {currentPage} of {totalPages}
//         </span>

//         <button
//           disabled={currentPage >= totalPages}
//           onClick={() => setCurrentPage((p) => p + 1)}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default RDReport;

import React, { useEffect, useState, useMemo, useRef } from "react";
import axios from "axios";
import "./DDReport.css";
import { Link, useNavigate } from "react-router-dom";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useSelector, useDispatch } from "react-redux";
import { FaRupeeSign, FaPrint, FaDownload, FaTimes } from "react-icons/fa";
import html2pdf from "html2pdf.js";

const secondaryTabs = [
  "All",
  "Active",
  "Closed",
  "Pending",
  "Matured",
  "Pre-Closed",
  "Reject",
];
const rowsPerPage = 10;

const RDReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeMainTab, setActiveMainTab] = useState("RD");
  const [activeSecondary, setActiveSecondary] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state) => state.userProfile);
  const [frequency, setFrequency] = useState("All");
  const [company, setCompany] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);

  // 🔹 Closing Letter Modal States
  const [showLetterModal, setShowLetterModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const letterRef = useRef(null);

  const handleViewEmi = (account) => {
    navigate(`/Deposit/EmiDetails/${account.id}`, { state: { account } });
  };

  const handleAlternatePay = (account) => {
    navigate(`/Banking/Report/AlternatePay/${account.id}`, {
      state: { account },
    });
  };

  // 🔹 Open Closing Letter Modal
  const handleOpenClosingLetter = (account) => {
    setSelectedAccount(account);
    setShowLetterModal(true);
  };

  // 🔹 Close Modal
  const handleCloseModal = () => {
    setShowLetterModal(false);
    setSelectedAccount(null);
  };

  useEffect(() => {
    if (!profile?.superAdminId) return;

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`,
        );
        const data = await res.json();

        if (res.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchCompany();
  }, [profile?.superAdminId]);

// 🔹 Download PDF Functionality (Fixed Logo Issue)
const handleDownloadPDF = () => {
  const element = letterRef.current;
  
  const opt = {
    margin: [10, 10, 10, 10],
    filename: `${selectedAccount?.customerName || selectedAccount?.accountNo || "Account"}_${selectedAccount?.accountType}_Closing_Letter.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { 
      scale: 2, 
      useCORS: true,      
      allowTaint: false,   
      logging: false 
    },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  };

  html2pdf().set(opt).from(element).save();
};

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // Fetch Accounts
  const fetchAccounts = async () => {
    try {
      setLoading(true);
      const superAdminId = profile.superAdminId || 14;
      const branchId = localStorage.getItem("userId") || 56;

      const res = await axios.get("https://payyug.in/api/deposit/list", {
        params: {
          superAdminId,
          branchId,
          page: currentPage,
          limit: rowsPerPage,
          accountType: activeMainTab,
          status: activeSecondary !== "All" ? activeSecondary : undefined,
        },
      });

      console.log("deposit list:", res);
      if (res.data.success) {
        setAccounts(res.data.data || []);
      } else {
        setAccounts([]);
      }
    } catch (err) {
      console.error("Error fetching deposit accounts:", err);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (profile?.superAdminId) {
      fetchAccounts();
    }
  }, [activeMainTab, activeSecondary, profile]);

  useEffect(() => {
    setCurrentPage(1);
  }, [activeMainTab, activeSecondary, searchQuery, frequency]);

  const filteredAccounts = useMemo(() => {
    let data = [...accounts];

    if (searchQuery.trim() !== "") {
      const query = searchQuery.toLowerCase();
      data = data.filter(
        (acc) =>
          acc.accountNo?.toLowerCase().includes(query) ||
          acc.customerName?.toLowerCase().includes(query),
      );
    }

    if (activeSecondary !== "All") {
      data = data.filter(
        (acc) => acc.status?.toLowerCase() === activeSecondary.toLowerCase(),
      );
    }

    if (frequency !== "All") {
      data = data.filter(
        (acc) =>
          acc.installmentFrequency?.toLowerCase() === frequency.toLowerCase(),
      );
    }

    return data;
  }, [accounts, activeSecondary, frequency, searchQuery]);

  const totalPages = filteredAccounts.length
    ? Math.ceil(filteredAccounts.length / rowsPerPage)
    : 0;

  const paginatedAccounts = useMemo(() => {
    const start = (currentPage - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return filteredAccounts.slice(start, end);
  }, [filteredAccounts, currentPage]);

  const renderTable = useMemo(() => {
    if (loading) {
      return (
        <tr>
          <td colSpan="15" style={{ textAlign: "center" }}>
            Loading...
          </td>
        </tr>
      );
    }

    if (!paginatedAccounts.length) {
      return (
        <tr>
          <td colSpan="15" style={{ textAlign: "center" }}>
            No Data Found
          </td>
        </tr>
      );
    }

    return paginatedAccounts.map((acc, index) => {
      const isPending = acc.status === "Pending";
      const isClosed =
        acc.status?.toLowerCase() === "closed" ||
        acc.status?.toLowerCase() === "requested" ||
        acc.status?.toLowerCase() === "force_closed" ||
        acc.status?.toLowerCase() === "pre-closed" ||
        acc.status?.toLowerCase() === "matured";

      return (
        <tr key={acc.id}>
          <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
          <td>{acc.accountNo}</td>
          <td>{acc.customerName || "--"}</td>
          <td>{acc.accountType || "--"}</td>
          <td>{acc.schemeName || "--"}</td>
          <td>{acc.installmentFrequency || "--"}</td>
          <td>{acc.roi || "--"}%</td>
          <td>₹{acc.amount?.toLocaleString() || 0}</td>
          <td>{acc.tenure || "--"}</td>
          <td>₹{acc.principalAmount?.toLocaleString() || "--"}</td>
          <td>
            {acc?.openingDate
              ? new Date(acc.openingDate).toLocaleDateString("en-GB")
              : "N/A"}
          </td>
          <td>{acc?.status}</td>

          {/* Passbook */}
          <td>
            <Link
              to={"/Banking/Report/RDDDPassbook"}
              state={{ row: acc }}
              className="rd-cirtificate-open-btn"
            >
              Open
            </Link>
          </td>

          {/* RD Certificate */}
          <td>
            {isPending ? (
              <span className="status-badge-not-approved">Not Approved</span>
            ) : (
              <Link
                to={"/Banking/Report/RDCertificates"}
                className="rd-cirtificate-open-btn"
                state={{ row: acc }}
              >
                Open
              </Link>
            )}
          </td>

          {/* Action */}
          <td>
            {isPending ? (
              <span className="status-badge-not-approved">Not Approved</span>
            ) : isClosed ? (
              <button
                className="DDFDReportview-btn letter-btn"
                onClick={() => handleOpenClosingLetter(acc)}
              >
                Closing Letter
              </button>
            ) : (
              <button
                className="DDFDReportview-btn"
                onClick={() => handleViewEmi(acc)}
              >
                <FaRupeeSign />
              </button>
            )}
          </td>
          <td>
            {isPending ? (
              <span className="status-badge-not-approved">Not Approved</span>
            ) : isClosed ? (
              <span className="status-badge-not-approved">Closed</span>
            ) : (
              <button
                className="DDFDReportview-btn"
                onClick={() => handleAlternatePay(acc)}
              >
                <FaRupeeSign />
              </button>
            )}
          </td>
        </tr>
      );
    });
  }, [paginatedAccounts, loading, currentPage]);

  return (
    <div className="DDFDReport-container">
      <h2 style={{ textAlign: "center", marginBottom: 10 }}>
        {activeMainTab} Account Report
      </h2>

      {/* Main Tabs */}
      <div className="DDFDReport-main-tabs">
        {["RD", "DD"].map((tab) => (
          <button
            key={tab}
            className={`DDFDReport-main-btn ${activeMainTab === tab ? "active" : ""}`}
            onClick={() => setActiveMainTab(tab)}
          >
            {tab} Report
          </button>
        ))}
      </div>

      {/* Secondary Tabs */}
      <div className="DDFDReport-secondary-tabs">
        {secondaryTabs.map((tab) => (
          <button
            key={tab}
            className={`DDFDReport-secondary-btn ${activeSecondary === tab ? "active" : ""}`}
            onClick={() => setActiveSecondary(tab)}
          >
            {tab}
          </button>
        ))}

        <div className="dropdown-filter">
          <select
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
          >
            <option value="All">All</option>
            <option value="Daily">Daily</option>
            <option value="Weekly">Weekly</option>
            <option value="Monthly">Monthly</option>
          </select>
        </div>
      </div>

      {/* Search */}
      <div className="DDFDReportsearch-box">
        <input
          type="text"
          placeholder="Search by Account No / Customer..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* Table */}
      <div className="DDFDReporttable-container">
        <table className="DDFDReport-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              <th>Scheme Name</th>
              <th>Installment Frequency</th>
              <th>ROI</th>
              <th>Installment Amount</th>
              <th>Tenure</th>
              <th>Principal Amount</th>
              <th>Opening Date</th>
              <th>Status</th>
              <th>Passbook</th>
              <th>Certificate</th>
              <th>Action</th>
              <th>Alternative Payment</th>
            </tr>
          </thead>
          <tbody>{renderTable}</tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="DDFDReportpagination">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          disabled={currentPage >= totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </div>

      {/* 🔹 CLOSING LETTER POPUP MODAL */}
      {showLetterModal && selectedAccount && (
        <div className="clr-modal-overlay">
          <div className="clr-modal-wrapper">
            {/* Modal Header Controls */}
            <div className="clr-actions-bar">
              <div className="clr-action-btns">
                <button
                  className="clr-btn-download"
                  onClick={handleDownloadPDF}
                >
                  <FaDownload /> Download PDF
                </button>
              </div>
              <button className="clr-btn-close" onClick={handleCloseModal}>
                <FaTimes />
              </button>
            </div>

            {/* Letter Printable Content */}
            <div className="clr-letter-container" ref={letterRef}>
              <div className="clr-header-flex">
                <div className="clr-brand-logo-box">
                  {company?.logoUrl && (
                    <img
                      src={company.logoUrl}
                      alt="Company Logo"
                      className="clr-brand-logo"
                      crossOrigin="anonymous"
                    />
                  )}
                </div>

                <div className="clr-corporate-info">
                  <h1>{(company?.name || "Techvision").toUpperCase()}</h1>
                  <p>
                    <b>Address:</b> {company?.address || "-"}
                  </p>
                  <p>
                    <b>CIN:</b> {company?.cin || "-"}
                  </p>
                  <p>
                    <b>Mobile:</b> {company?.contact || "-"}
                  </p>
                  <p>
                    <b>Email:</b> {company?.email || "-"}
                  </p>
                </div>
              </div>

              <div className="clr-letter-meta">
                <p>
                  <strong>Ref No:</strong> CLOS/{selectedAccount.accountNo}
                </p>
                <p>
                  <strong>Date:</strong>{" "}
                  {new Date(selectedAccount.closedDate).toLocaleDateString("en-GB")|| new Date().toLocaleDateString("en-GB")}
                </p>
              </div>

              <h3 className="clr-letter-title">
               {selectedAccount.accountType} ACCOUNT CLOSING ACKNOWLEDGEMENT LETTER
              </h3>

              <div className="clr-letter-body">
                <p>To,</p>
                <p>
                  <strong>
                    {selectedAccount.customerName || "Valued Customer"}
                  </strong>
                </p>
                <p>Account Holder</p>

                <br />

                <p>Dear Sir/Madam,</p>
                <p>
                  This is to certify that your{" "}
                  <strong>{selectedAccount.accountType || "Deposit"}</strong>{" "}
                  Account bearing Account Number{" "}
                  <strong>{selectedAccount.accountNo}</strong> registered with
                  our branch has been successfully closed on{" "}
                  <strong>
                    {selectedAccount.closedDate
                      ? new Date(
                          selectedAccount.closedDate,
                        ).toLocaleDateString("en-GB")
                      : new Date().toLocaleDateString("en-GB")}
                  </strong>
                  .
                </p>

                <br />

                <table className="clr-letter-table">
                  <tbody>
                    <tr>
                      <td>
                        <strong>Account Number:</strong>
                      </td>
                      <td>{selectedAccount.accountNo}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Account Type (Scheme):</strong>
                      </td>
                      <td>
                        {selectedAccount.accountType} (
                        {selectedAccount.schemeName || "N/A"})
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Installment Amount:</strong>
                      </td>
                      <td>
                        ₹{selectedAccount.amount?.toLocaleString() || 0} (
                        {selectedAccount.installmentFrequency})
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total Deposited:</strong>
                      </td>
                      <td>
                        ₹
                        {selectedAccount?.totalDeposited.toLocaleString()||selectedAccount.principalAmount?.toLocaleString() || 0}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Closure Status:</strong>
                      </td>
                      <td>
                        <strong>{selectedAccount.status?.toUpperCase()}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <br />

                <p>
                  All full and final settlements associated with this account
                  have been processed. No further transactions will be allowed
                  on this account number.
                </p>

                <p>
                  We thank you for your association with us and look forward to
                  serving you again in the future.
                </p>
              </div>

              <div className="clr-letter-footer">
                <div className="clr-signature-box">
                  <p>Customer Signature</p>
                </div>
                <div className="clr-signature-box">
                  <p>Authorized Signatory</p>
                  <p>
                    <strong>Branch Manager</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RDReport;
